export default __webpack_public_path__ + "static/media/Sneezing-rafiki.bcea291b.svg";